// extracted by mini-css-extract-plugin
export default {"wrapper":"Connections_wrapper__ECpQ9","column":"Connections_column__h4q2x"};